export const formatAttributeSlug = (name?: string): string => {
  if (!name) {
    return "";
  }

  return name
    .replace(/^pa_/, "")
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
};

export const getAttributeLabel = (attr?: {
  name?: string;
  label?: string;
}): string => {
  const label = (attr?.label || "").replace(/:\s*$/, "").trim();

  if (label && !/^pa_/i.test(label)) {
    return label;
  }

  return formatAttributeSlug(attr?.name || label);
};
